__turbopack_context__.v({
  "arrowLink": "qPiceG_arrowLink",
  "availability": "qPiceG_availability",
  "band": "qPiceG_band",
  "bandTitle": "qPiceG_bandTitle",
  "book": "qPiceG_book",
  "bookActions": "qPiceG_bookActions",
  "bookSection": "qPiceG_bookSection",
  "breadcrumb": "qPiceG_breadcrumb",
  "ctas": "qPiceG_ctas",
  "deliverable": "qPiceG_deliverable",
  "deliverables": "qPiceG_deliverables",
  "fact": "qPiceG_fact",
  "facts": "qPiceG_facts",
  "faq": "qPiceG_faq",
  "hero": "qPiceG_hero",
  "heroTitle": "qPiceG_heroTitle",
  "lead": "qPiceG_lead",
  "limitList": "qPiceG_limitList",
  "limits": "qPiceG_limits",
  "muted": "qPiceG_muted",
  "onPanel": "qPiceG_onPanel",
  "price": "qPiceG_price",
  "priceCard": "qPiceG_priceCard",
  "proof": "qPiceG_proof",
  "proofCard": "qPiceG_proofCard",
  "relatedWork": "qPiceG_relatedWork",
  "root": "qPiceG_root",
  "section": "qPiceG_section",
  "sectionTitle": "qPiceG_sectionTitle",
  "sibling": "qPiceG_sibling",
  "siblingHead": "qPiceG_siblingHead",
  "siblingLink": "qPiceG_siblingLink",
  "siblingMeta": "qPiceG_siblingMeta",
  "siblingName": "qPiceG_siblingName",
  "siblings": "qPiceG_siblings",
  "signal": "qPiceG_signal",
  "signals": "qPiceG_signals",
  "split": "qPiceG_split",
  "stack": "qPiceG_stack",
  "step": "qPiceG_step",
  "stepNumber": "qPiceG_stepNumber",
  "steps": "qPiceG_steps",
  "trust": "qPiceG_trust",
});
